import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModal } from '../../redux-store/modalReducer'
import InputBox from '../../common-components/InputBox'
import { electionTypeArray } from '../../utilities/electionTypeArray'
import { partyArray } from '../../utilities/partyArray'
import FilterButton from '../../common-components/FilterButton'
import useValidator from '../../utilities/useValidator'
import Swal from 'sweetalert2'
import { communication } from '../../services/communication'
import { hideLoader, showLoader } from '../../redux-store/loaderReducer'
import { useNavigate } from 'react-router-dom'
import Loader from '../../utilities/Loader'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UpdateElection = ({ electionId, fetchElectionList }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loader = useSelector((state) => state.loaderReducer.loaderState);
    const [validator, showValidationMessage] = useValidator();
    const [electionData, setElectionData] = useState(
        {
            name: "",
            type: "",
            party: "",
            year: "",
            electionDate: new Date()
        }
    );

    const fetchElectionDetailById = async () => {
        try {
            const responseFromServer = await communication.getElectionDetailById(electionId);
            if (responseFromServer?.data?.status === "SUCCESS") {
                setElectionData(responseFromServer?.data?.elections);
            } else if (responseFromServer?.data?.status === "JWT_INVALID") {
                dispatch(hideLoader());
                Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
                navigate("/login");
            } else {
                setElectionData({});
                Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
            }
        } catch (error) {
            Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
        }
    }

    //Add Election
    const updateElection = async () => {
        try {
            if (!validator.allValid()) {
                showValidationMessage(true);
                return false
            }
            const dataToSend = {
                electionId,
                ...electionData
            }
            dispatch(showLoader());
            const serverResponse = await communication.updateElection(dataToSend);
            if (serverResponse?.data?.status === "SUCCESS") {
                dispatch(hideLoader());
                dispatch(toggleModal(""));
                fetchElectionList();
                Swal.fire({ text: serverResponse?.data?.message, icon: "success" });
            } else if (serverResponse?.data?.status === "JWT_INVALID") {
                dispatch(hideLoader());
                Swal.fire({ text: serverResponse?.data?.message, icon: "warning" });
                navigate("/login");
            } else {
                dispatch(hideLoader());
                Swal.fire({ text: serverResponse?.data?.message, icon: "warning" });
            }
        } catch (error) {
            dispatch(hideLoader());
            Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
        }
    }

    useEffect(() => {
        fetchElectionDetailById();
    }, []);

    return (
        <>
            {loader === true ?
                <Loader />
                :
                <div className="modal_wrapper">
                    <div className="card_wrapper">
                        <div className="card_header">
                            <div className="title">
                                <h5>Update Election</h5>
                            </div>
                            <div className="close_button" onClick={() => dispatch(toggleModal(""))}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                        <div className="card_body">
                            <div className="row">
                                <div className="col-6">
                                    <div className="input_box_wrapper">
                                        <label>Election Name</label>
                                        <InputBox type="text" name="name" value={electionData.name} onChange={(event) => setElectionData({ ...electionData, name: event.target.value })} placeholder="Enter Election Name" />
                                        {validator.message("name", electionData.name, "required", {
                                            messages: {
                                                required: "Election Name is required"
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="input_box_wrapper">
                                        <label>Election Type</label>
                                        <select name="type" onChange={(event) => setElectionData({ ...electionData, type: event.target.value })} className="form-select">
                                            <option value="">Select Election Type</option>
                                            {electionTypeArray?.map((electionType, index) => {
                                                return (
                                                    <option value={electionType} selected={electionType === electionData.type} key={index}>{electionType}</option>
                                                );
                                            })}
                                        </select>
                                        {validator.message("type", electionData.type, "required", {
                                            messages: {
                                                required: "Election Type is required"
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="input_box_wrapper">
                                        <label>Party</label>
                                        <select name="party" onChange={(event) => setElectionData({ ...electionData, party: event.target.value })} className="form-select party_select_box">
                                            <option value="">Select Party</option>
                                            {partyArray?.map((party, index) => {
                                                return (
                                                    <option value={party} selected={party === electionData.party} key={index}>{party}</option>
                                                );
                                            })}
                                        </select>
                                        {validator.message("party", electionData.party, "required", {
                                            messages: {
                                                required: "Party Name is required"
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="input_box_wrapper">
                                        <label>Year</label>
                                        <InputBox type="number" name="year" value={electionData.year} onChange={(event) => setElectionData({ ...electionData, year: event.target.value })} placeholder="Enter Election Year" />
                                        {validator.message("year", electionData.year, "required|min:4|max:4", {
                                            messages: {
                                                required: "Election Year is required"
                                            }
                                        })}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="input_box_wrapper">
                                        <label>Election Date</label>
                                        <DatePicker name="electionDate"  selected={new Date(electionData.electionDate)} onChange={(event) => setElectionData({ ...electionData, electionDate: event })} placeholder="Enter Election Date" />
                                    </div>
                                </div>
                                <div className="submit_button_wrapper">
                                    <FilterButton name="Update" onClick={() => updateElection()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default UpdateElection